import { Backdrop } from '@mui/material';
import styled from '@emotion/styled';

export const CustomizedBackdrop = styled(Backdrop)`
  color: #ffffff;
  z-index: 10000;
`;
